import {
  Datagrid,
  DateField,
  ReferenceManyField,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import { Typography } from '@mui/material';

import AddNoteButton from '../../../components/AddNoteButton';
import RoutePaths from '../../../routes';

function CustomerNotes(props) {
  return (
    <SimpleShowLayout {...props}>
      <ReferenceManyField
        title=''
        reference={RoutePaths.notes}
        target='user_id'
        label=''
        sort={{ field: 'created_at', order: 'DESC' }}
      >
        <Datagrid
          bulkActionButtons={false}
          empty={
            <Typography variant='body2' sx={{ padding: '16px 16px 24px' }}>
              No notes found
            </Typography>
          }
        >
          <DateField
            source='created_at'
            label='Date'
            showTime={true}
            sortable={false}
          />
          <TextField
            source='agent_email'
            label='Agent Identifier'
            sortable={false}
          />
          <TextField source='note' label='Notes' sortable={false} />
        </Datagrid>
      </ReferenceManyField>
      <AddNoteButton />
    </SimpleShowLayout>
  );
}

export default CustomerNotes;
